<template>
    <u-table-line v-bind="$attrs" class="table-secondary">
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
    </u-table-line>
</template>

<script>
import UTableLine from "@/components/publish/styles/tables/u-table-line.vue";

export default {
    props: {},
    components: {
        UTableLine,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
